export default "__VITE_ASSET__308ecec4__"